import { Circulo } from './styles'

const BotaoAdicionar = () => <Circulo to="/novo">+</Circulo>

export default BotaoAdicionar
